export enum ReportsTemplatesRoutes {
    template1 = "template1",
    template2 = "template2",
    template3 = "template3",
    template4 = "template4",
    template5 = "template5",
    template6 = "template6",
    template7 = "template7",
}
